/**
 * 时间格式化工具函数
 */

/**
 * 将秒数格式化为 MM:SS 格式
 * @param {number} seconds - 秒数
 * @returns {string} 格式化的时间字符串 (MM:SS)
 */
export const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

/**
 * 将秒数格式化为更友好的显示格式
 * @param {number} seconds - 秒数
 * @returns {string} 格式化的时间字符串 (如 "1小时23分钟" 或 "45分钟30秒")
 */
export const formatTimeFriendly = (seconds) => {
  if (seconds < 60) {
    return `${seconds}秒`;
  }
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  
  const parts = [];
  if (hours > 0) {
    parts.push(`${hours}小时`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}分钟`);
  }
  if (secs > 0 && hours === 0) {
    parts.push(`${secs}秒`);
  }
  
  return parts.join('');
};

